<template>
	<div class="index">
		<pageCart>
			<products/>
		</pageCart>
	</div>
</template>

<script>
import pageCart from "@/components/layouts/page/cart.vue";
import products from "./products/index.vue";

export default {
	components: {pageCart, products}
}
</script>

<style lang="scss" scoped>
.index {

}
</style>
